export function normalizeLocalContacts(users, currentUserId) {
  const contactsById = {};
  for (const user of users) {
    if (user.id === currentUserId) {
      continue;
    }
    contactsById[user.id] = {
      ...user,
      avatarUrl: user.avatar || '',
      status: user.status || 0,
      email: user.email || '',
      phone: user.phone || '',
      signInfo: user.signInfo || '',
    };
  }
  return contactsById;
}

export function normalizeLocalGroups(groups) {
  const groupsById = {};
  for (const group of groups) {
    groupsById[group.id] = {
      ...group,
      avatarUrl: group.avatar || '',
      shieldStatus: group.shieldStatus || 0,
      memberIds: group.memberIds || [],
    };
  }
  return groupsById;
}

export function buildLocalSessionMap({
  sessions,
  currentUserId,
  contactsById,
  groupsById,
  resolveSessionPresentation,
}) {
  const sessionsByKey = {};
  for (const session of sessions) {
    if (session.sessionType === 'single' && session.sessionId === currentUserId) {
      continue;
    }
    const presentation = resolveSessionPresentation(
      session.sessionType,
      session.sessionId,
      contactsById,
      groupsById,
    );
    sessionsByKey[session.sessionKey] = {
      ...session,
      title: presentation.title,
      subtitle: presentation.subtitle,
      avatarText: presentation.avatarText,
      messages: [],
      historyState: 'ready',
      historyError: null,
      hasMoreHistory: true,
    };
  }
  return sessionsByKey;
}

export async function loadLocalChatSnapshot({
  repository,
  currentUserId,
  resolveSessionPresentation,
}) {
  const [users, groups, sessions] = await Promise.all([
    repository.getAllUsers(),
    repository.getAllGroups(),
    repository.getAllSessions(),
  ]);
  const contactsById = normalizeLocalContacts(users, currentUserId);
  const groupsById = normalizeLocalGroups(groups);
  const sessionsByKey = buildLocalSessionMap({
    sessions,
    currentUserId,
    contactsById,
    groupsById,
    resolveSessionPresentation,
  });

  return {
    contactsById,
    groupsById,
    sessionsByKey,
  };
}
